
  import { Vue, Options } from "vue-class-component";
  import { useStore } from "vuex";
  import { getPageGroupTitle } from "@/utils/pages";
  
  @Options({
    props: {
      showNavigationModal: Boolean,
      groups: Object,
      language: String
    },
    methods: {
      getPageGroupTitle: getPageGroupTitle
    },
    emits: ['navigateToGroup', 'clicked']
  } as any)
  export default class NavigationModal extends Vue {
    page: any = null;
    language: any = null

    globalStore = useStore();

    closeModal() {
      this.resetHeaderZIndex();
      this.$emit("clicked", "accepted");
    }

    resetHeaderZIndex() {
      const el: any = document.getElementById('header')
      el.style.zIndex = "10";
    }
  }
